import { cn } from '../../lib/utils';
import { Progress } from '../ui/progress';

export function KpiCard({ label, value, rawValue, goal, icon: Icon, accent = 'magenta', suffix = '', testid }) {
  const numForProgress = typeof rawValue === 'number' ? rawValue : (typeof value === 'number' ? value : 0);
  const pct = goal ? Math.min(100, Math.round((numForProgress / goal) * 100)) : null;
  const iconBg = accent === 'navy' ? 'bg-navy/10 text-navy' : 'bg-magenta/10 text-magenta';

  return (
    <div
      className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all animate-in"
      data-testid={testid}
    >
      <div className="flex items-start justify-between gap-3 mb-4">
        <div>
          <div className="text-[11px] font-semibold tracking-[0.12em] uppercase text-slate-500">{label}</div>
          <div className="font-heading text-3xl md:text-4xl font-bold text-navy mt-1.5">
            {value}
            {suffix}
          </div>
        </div>
        {Icon && (
          <div className={cn('w-10 h-10 rounded-full flex items-center justify-center shrink-0', iconBg)}>
            <Icon className="w-5 h-5" />
          </div>
        )}
      </div>
      {pct !== null && (
        <>
          <div className="flex items-center justify-between text-xs mb-1.5">
            <span className="text-slate-500">Goal progress</span>
            <span className="font-semibold text-navy">{pct}%</span>
          </div>
          <Progress value={pct} className="h-1.5 bg-slate-100" />
          <div className="text-[11px] text-slate-400 mt-1.5">Target: {goal}{suffix}</div>
        </>
      )}
    </div>
  );
}
